module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "klickbox-step-description",
    staticStyle: {
      "margin-top": "-11px"
    }
  }, [_c('div', {
    staticClass: "klickbox-edit-title"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('general.labels.description')) + "\n    "), _c('description-checkbox')], 1), _vm._v(" "), _c('text-editor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.descriptionVisibility),
      expression: "descriptionVisibility"
    }],
    attrs: {
      "content": _vm.step.description_text,
      "change": _vm.changed,
      "placeholder": _vm.$t('edit.canvas.question_description_placeholder')
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "klickbox-step-bar"
  })], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-0217acd2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/Description.vue
 ** module id = 744
 ** module chunks = 1
 **/